import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	failedBuildOrDeploymentLabelNonfinal: {
		id: 'periscope.common.task-type.failed-build-or-deployment-label-nonfinal',
		defaultMessage:
			'failed {suggestionType, select, WorkSuggestionsBuildTask{build} other{deployment}}',
		description: 'Text shown in failed build or deployment task label',
	},
	pullRequestIconLabelNonfinal: {
		id: 'periscope.common.task-type.pull-request-icon-label-nonfinal',
		defaultMessage: 'pull request',
		description: 'Text shown in pull request icon label',
	},
	criticalVulnerabilityIconLabelNonfinal: {
		id: 'periscope.common.task-type.critical-vulnerability-icon-label-nonfinal',
		defaultMessage: 'critical vulnerability',
		description: 'Text shown in critical vulnerability icon label',
	},
	blockingIssueIconLabelNonfinal: {
		id: 'periscope.common.task-type.blocking-issue-icon-label-nonfinal',
		defaultMessage: 'blocking issue',
		description: 'Text shown in blocking issue icon label',
	},
	failedBuildTaskTitleNonfinal: {
		id: 'periscope.common.task-type.failed-build-task-title-nonfinal',
		defaultMessage: 'Fix failed build',
		description: 'Text shown in failed build task title',
	},
	failedDeploymentTaskTitleNonfinal: {
		id: 'periscope.common.task-type.failed-deployment-task-title-nonfinal',
		defaultMessage: 'Debug failed deployment',
		description: 'Text shown in failed deployment task title',
	},
	pullRequestReviewTaskTitleNonfinal: {
		id: 'periscope.common.task-type.pull-request-review-task-title-nonfinal',
		defaultMessage: 'Review pull request',
		description: 'Text shown in pull request review task title',
	},
	pullRequestNeedsWorkTaskTitleNonfinal: {
		id: 'periscope.common.task-type.pull-request-needs-work-task-title-nonfinal',
		defaultMessage: 'View changes requested on your pull request',
		description: 'Text shown in pull request needs work task title',
	},
	pullRequestInactiveTaskTitleNonfinal: {
		id: 'periscope.common.task-type.pull-request-inactive-task-title-nonfinal',
		defaultMessage: 'View inactive pull request',
		description: 'Text shown in pull request stale task title',
	},
	criticalVulnerabilityTaskTitleNonfinal: {
		id: 'periscope.common.task-type.critical-vulnerability-task-title-nonfinal',
		defaultMessage: 'Resolve security vulnerability',
		description: 'Text shown in critical vulnerability task title',
	},
	blockingIssueTaskTitleNonfinal: {
		id: 'periscope.common.task-type.blocking-issue-task-title-nonfinal',
		defaultMessage: 'View blocking issue',
		description: 'Text shown in blocking issue task title',
	},
	autoDevJobsPlanSuccessTaskTitleNonfinal: {
		id: 'periscope.common.task-type.auto-dev-jobs-plan-success-task-title-nonfinal',
		defaultMessage: 'Review Autodev plan',
		description:
			'Text shown in Autodev (the feature we have about auto development) planning success task title',
	},
	compassAnnouncementTaskTitleNonfinal: {
		id: 'periscope.common.task-type.compass-announcement-task-title-nonfinal',
		defaultMessage: 'Acknowledge Compass component announcement',
		description: 'Text shown in compass announcement work suggestion task title',
	},
	isSuggestionHelpfulNonfinal: {
		id: 'periscope.common.task-type.is-suggestion-helpful-nonfinal',
		defaultMessage: 'Is this suggestion helpful?',
		description: 'Text shown for like button',
	},
	likeLabelNonfinal: {
		id: 'periscope.common.task-type.like-label-nonfinal',
		defaultMessage: 'Like',
		description: 'Text shown for like button',
	},
	dislikeLabelNonfinal: {
		id: 'periscope.common.task-type.dislike-label-nonfinal',
		defaultMessage: 'Dislike',
		description: 'Text shown for dislike button',
	},
	snoozeLabelNonfinal: {
		id: 'periscope.common.task-type.snooze-label-nonfinal',
		defaultMessage: 'Snooze',
		description: 'Text for snooze button label',
	},
	removeLabelNonfinal: {
		id: 'periscope.common.task-type.remove-label-nonfinal',
		defaultMessage: 'Remove',
		description: 'Text for remove button label',
	},
	snoozeTooltipNonfinal: {
		id: 'periscope.common.task-type.snooze-tooltip-nonfinal',
		defaultMessage: 'Snooze for 24 hours',
		description: 'Text for snooze button tooltip',
	},
	removeTooltipNonfinal: {
		id: 'periscope.common.task-type.remove-tooltip-nonfinal',
		defaultMessage: 'Remove',
		description: 'Text for remove button tooltip',
	},
	linkIconLabelNonfinal: {
		id: 'periscope.common.task-type.link-icon-label-nonfinal',
		defaultMessage: 'open icon',
		description: 'Text for link icon label',
	},
});
